/** @format */
/**
 * @name Transform
 * @param columns Array
 * @param body  Array
 */
export function transformVerticalData(columns, body) {
  const rows = [];
  columns.map((column, indexColumn) => {
    const schemaTransformedTarget = [column];
    for (let indexContent = 0; indexContent < body.length; indexContent++) {
      const bodyContentValues = body[indexContent];
      for (let indexRowContent = 0; indexRowContent < bodyContentValues.length; indexRowContent++) {
        if (indexRowContent === indexColumn) {
          schemaTransformedTarget.push(bodyContentValues[indexRowContent]);
          break;
        }
      }
    }
    rows.push(schemaTransformedTarget);
  });
  return rows;
}
